<template>
    <a-modal
      :visible="moveToData ? true : false"
      title="Move Language"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <a-row>
        <a-col :xs="24" :lg="24">
          <!-- 国家 -->
          <a-form-item>
            <span slot="label">Move <strong>{{ moveToData ? moveToData.enName : '' }}</strong> after</span>
            <a-select
              v-model="moveToCurrentId"
              style="width: 100%;"
              :showSearch="true"
              optionFilterProp="children"
              v-decorator="[
                'languages',
                { rules: [{ required: true, message: 'Please select languages!' }] },
              ]"
            >
              <a-select-option :value="'top'">Top</a-select-option>
              <a-select-option v-for="i in languageList" :key="'languages-' + i.id" :value="i.id">{{ i.enName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <template slot="footer">
          <a-button type="primary" @click="handleOk" :loading="saving">
            Confirm
          </a-button>
      </template>
    </a-modal>
</template>

<script>
import LanguageApi from '@/api/dict/api-language'

export default {
  name: 'LanguageMove',
  components: {
  },
   props: {
    initData: {
      type: [Object],
      default: null
    }
  },
  data () {
    return {
      languageList: [],
      moveToData: null,
      moveToCurrentId: null,
      saving: false,
    }
  },
  created () {
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.saving = false
      this.moveToCurrentId = 'top'
      this.moveToData = this.initData
      const resLanguage = await LanguageApi.list()
      const languageList = resLanguage.data
      this.languageList = languageList

    },
    async handleOk () {
      this.saving = false
      if (this.moveToCurrentId === 'top') {
        await LanguageApi.moveTo(this.moveToData.id)
      } else {
        await LanguageApi.moveTo(this.moveToData.id, this.moveToCurrentId)
      }
      this.saving = true
      this.$emit('ok')
    },
    handleCancel () {
      this.$emit('cancel')
    }
  },
  watch: {
    initData () {
      this.loadData()
    }
  }
}
</script>
